import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'dat.gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { InteractionManager } from "three.interactive";


let planeGeo;
let planeMat;
let joyManager;
let fwdValue = 0;
let bkdValue = 0;
let rgtValue = 0;
let lftValue = 0;
let tempVector = new THREE.Vector3();
let upVector = new THREE.Vector3(0, 1, 0);
/**
 * Base
 */

// Debug
//const gui = new dat.GUI()


// Canvas
const canvas = document.querySelector('canvas.webgl')


// Scene
const scene = new THREE.Scene()

const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('/draco/')


/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.25)
scene.add(ambientLight)



const directionalLight = new THREE.DirectionalLight('#ffffff', 8);
directionalLight.position.set(800, 700, -72.253);
let d = 1000;
let r = 100;
let mapSize = 4096;
directionalLight.castShadow = true;
directionalLight.shadow.radius = r;
directionalLight.visible=true;
directionalLight.shadow.mapSize.width = mapSize;
directionalLight.shadow.mapSize.height = mapSize;
directionalLight.shadow.camera.top = directionalLight.shadow.camera.right = d;
directionalLight.shadow.camera.bottom = directionalLight.shadow.camera.left = -d;
directionalLight.shadow.camera.near = 1;
directionalLight.shadow.camera.far = 10000;
directionalLight.shadow.camera.visible = true;
directionalLight.target.updateMatrixWorld();
scene.add(directionalLight);

// gui.add(directionalLight, 'intensity').min(0).max(10).step(0.001).name('lightIntensity')
// gui.add(directionalLight.position, 'x').min(- 1000).max(1000).step(0.001).name('lightX')
// gui.add(directionalLight.position, 'y').min(- 1000).max(1000).step(0.001).name('lightY')
// gui.add(directionalLight.position, 'z').min(- 1000).max(1000).step(0.001).name('lightZ')
// const helper = new THREE.DirectionalLightHelper( directionalLight, 5 );
// scene.add( helper );

// //Light helper for directional light
// const directionalLightHelper = new THREE.DirectionalLightHelper(directionalLight, 0.2)

   
function addJoystick(){
    const options = {
         zone: document.getElementById('joystickWrapper1'),
         size: 120,
         multitouch: true,
         maxNumberOfNipples: 2,
         mode: 'static',
         restJoystick: true,
         shape: 'circle',
         // position: { top: 20, left: 20 },
         dynamicPage: true,
         color:'white',
       }    
   joyManager = nipplejs.create(options);
   
 joyManager['0'].on('move', function (evt, data) {
         const forward = data.vector.y
         const turn = data.vector.x
 
         if (forward > 0) {
           fwdValue = Math.abs(forward)
           bkdValue = 0
         } else if (forward < 0) {
           fwdValue = 0
           bkdValue = Math.abs(forward)
         }
 
         if (turn > 0) {
           lftValue = 0
           rgtValue = Math.abs(turn)
         } else if (turn < 0) {
           lftValue = Math.abs(turn)
           rgtValue = 0
         }
       })
 
      joyManager['0'].on('end', function (evt) {
         bkdValue = 0
         fwdValue = 0
         lftValue = 0
         rgtValue = 0
       })
   
 }

    
function updatePlayer(){
    // move the player
    const angle = controls.getAzimuthalAngle()  
      if (fwdValue > 0) {
          tempVector
            .set(0, 0, -fwdValue)
            .applyAxisAngle(upVector, angle)
            camPoint.position.addScaledVector(
            tempVector,
            .5
          )
        }  
        if (bkdValue > 0) {
          tempVector
            .set(0, 0, bkdValue)
            .applyAxisAngle(upVector, angle)
            camPoint.position.addScaledVector(
            tempVector,
            .5
          )
        }
        if (lftValue > 0) {
          tempVector
            .set(-lftValue, 0, 0)
            .applyAxisAngle(upVector, angle)
            camPoint.position.addScaledVector(
            tempVector,
            .5
          )
        }
        if (rgtValue > 0) {
          tempVector
            .set(rgtValue, 0, 0)
            .applyAxisAngle(upVector, angle)
            camPoint.position.addScaledVector(
            tempVector,
            .5
          )
        }
    
        camPoint.updateMatrixWorld()
    
  //  this.controls.target.set( this.camPoint.position.x, this.camPoint.position.y, this.camPoint.position.z );
    // reposition camera
    camera.position.sub(controls.target)
    controls.target.copy(camPoint.position)
    camera.position.add(camPoint.position) 
  }
 
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

var threshold1 = 500;
var threshold2 = 500;
function changeThreshold() {

    threshold1 = randomInteger(1, 8) * 100
    threshold2 = randomInteger(1, 10) * 100

}
function openNav() {
    document.getElementById("mySidenav").style.width = "250px";
  }

function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  
/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 1000)
camera.position.set(-15.647204595488851,103.84822017522242,157.84923048167747)
scene.add(camera)

setInterval(changeThreshold, 5000)

var object1
var object2
/**
 * Models
 */


//We have put the loading of gltf in a function so we can 
//pass a new argument for loading a new view. 
const targetDiv = document.getElementById("show_route_cards");
const showRoute = document.getElementById("show_route");
const processCard = document.getElementById("process_card");
const vectorImageCard = document.getElementById("vector_image");
const showAnimation = document.getElementById("show_animation");
const toggleView = document.getElementById("toggle_view")
const showExit = document.getElementById("show_exit");
const showWebsite = document.getElementById("show_wdebsite");
const video = document.getElementById("video");
const videoDiv = document.getElementById("videoDiv");
const wrapFix = document.getElementById("wrapFix");
const cardCloseProcess = document.getElementById("card_close_process_card");
const cardCloseVector = document.getElementById("card_close_vector_image");
// const showRouteCards = document.getElementById("show_route_cards")




var requestID;
var mixer;
var start_route_point;
var end_route_point;
var camPoint;

//live chart
window.onload = function () {
    addJoystick();
    var dps = []; // dataPoints
    var chart = new CanvasJS.Chart("chartContainer", {
       
        data: [{
            type: "line",
            dataPoints: dps
        }]
    });
    
    var xVal = 0;
    var yVal = 100; 
    var updateInterval = 1000;
    var dataLength = 20; // number of dataPoints visible at any point
    
    var updateChart = function (count) {
    
        count = count || 1;
    
        for (var j = 0; j < count; j++) {
            yVal = yVal +  Math.round(5 + Math.random() *(-5-5));
            dps.push({
                x: xVal,
                y: yVal
            });
            xVal++;
        }
    
        if (dps.length > dataLength) {
            dps.shift();
        }
    
        chart.render();
    };
    
    updateChart(dataLength);
    setInterval(function(){updateChart()}, updateInterval);
    
    }
    

//let skyboxGeo = new THREE.BoxGeometry(10000, 10000, 10000);
//skybox = new THREE.Mesh(skyboxGeo);
//scene.add(skybox);

camPoint = new THREE.Mesh(planeGeo,planeMat);
//camPoint.rotateX(-Math.PI / 2);
camPoint.receiveShadow=true;
scene.add(camPoint);
camPoint.position.set(0,0,0);



//var gltf_path_full = "/models/KJ_Model/keirtokaari_01.gltf"
var gltf_path_full = "/models/KJ_Oiva/KJ_Oiva_Piste_01.gltf"
var gltf_path_current = gltf_path_full
var oldGltf;
var action_animation;

// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)
function load_model(gltf_path) {
gltfLoader.load(
    // '/models/Heatmap_Model_01/Heatmap_Model_01/Heatmap_Model_01.gltf',
    // '/models/Factory/Factory/Factory.gltf',
    // '/models/Factory_Main_Light_01/Factory_Demo_Light_01.gltf',
    // '/models/Building_02_Test_04_export_gltf/Building_02_Test_04.gltf',
    // '/models/Demo_Building_With_C_D_01/demo.gltf',
    gltf_path,

    
    (gltf) => {
      gltf.scene.traverse(function(model) {
        if (model.isMesh) {
          model.castShadow = true;
          model.receiveShadow = true;
        }
      });
        console.log('this is the new gltf path'+ gltf_path);
        if(oldGltf!=null)
        {
            console.log("in here");
            scene.remove(oldGltf.scene);
            oldGltf=gltf;
        } else {          
            console.log("in here 2");
            oldGltf=gltf;
        }
        const root = gltf.scene;
        scene.add(root);
        mixer = new THREE.AnimationMixer(gltf.scene);
        // console.log(dumpObject(root).join('\n'));
        gltf.animations.forEach((clip) => { mixer.clipAction(clip).play(); });
        console.log("Animations: ", gltf.animations); // Array<THREE.AnimationClip>

        // stop man fridge animation.
        // action_animation = mixer.clipAction(gltf.animations[19])
        // action_animation.stop();

        //fetch the 3d object we're trying to click on for opening the pop up box. 
        let object_to_click = root.getObjectByName("kylmalaitteet_board", true)
        console.log(object_to_click)

        const s = new THREE.Box3().setFromObject(gltf.scene).getSize(new THREE.Vector3(0, 0, 0));
        const sizes2 = [s.nx, s.y, s.z];
        const planeSize = Math.max(...sizes2) * 10;
        planeGeo = new THREE.PlaneBufferGeometry(planeSize, planeSize);
        //const planeMat = new THREE.MeshStandardMaterial({ color: 0xffffff, side: THREE.DoubleSide});
        planeMat = new THREE.ShadowMaterial();
        planeMat.opacity = 0.5;

        interactionManager.add(object_to_click);
        object_to_click.addEventListener("click", (event) => {
        console.log(event)
        if (processCard.style.display !== "none") {
          processCard.style.display = "none";
        } else {
          processCard.style.display = "block";
        }

  //open up the 2nd pop up. 
    // processCard.style.display = "block"
})
    }
)
}

load_model(gltf_path_current);

/**
 * Sizes
 */

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

function dumpObject(obj, lines = [], isLast = true, prefix = '') {
    const localPrefix = isLast ? '└─' : '├─';
    lines.push(`${prefix}${prefix ? localPrefix : ''}${obj.name || '*no-name*'} [${obj.type}]`);
    const newPrefix = prefix + (isLast ? '  ' : '│ ');
    const lastNdx = obj.children.length - 1;
    obj.children.forEach((child, ndx) => {
        const isLast = ndx === lastNdx;
        dumpObject(child, lines, isLast, newPrefix);
    });
    return lines;
}

// Controls
const controls = new OrbitControls(camera, canvas)
controls.target.set(0, 0.75, 0)
controls.enableDamping = true
controls.dampingFactor = 0.07; // friction
controls.rotateSpeed = 0.08; // mouse sensitivity

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})

renderer.physicallyCorrectLights = true
renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.autoClear=true
renderer.shadowMap.autoUpdate = true;
renderer.toneMappingExposure = 3
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// gui.add(renderer, 'toneMapping', {
//     No: THREE.NoToneMapping,
//     Linear: THREE.LinearToneMapping,
//     Reinhard: THREE.ReinhardToneMapping,
//     Cineon: THREE.CineonToneMapping,
//     ACESFilmic: THREE.ACESFilmicToneMapping
// })
// .onFinishChange(() =>
//     {
//         renderer.toneMapping = Number(renderer.toneMapping)
//         updateAllMaterials()
//     })

//     gui.add(renderer, 'toneMappingExposure').min(0).max(10).step(0.001)

scene.updateMatrixWorld();

const interactionManager = new InteractionManager(
    renderer,
    camera,
    renderer.domElement
);

function stopAnimation() {

    cancelAnimationFrame(requestID);

}

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Update controls
    controls.update()

    interactionManager.update();
    updatePlayer();
    // Render
    renderer.render(scene, camera)

    requestID = window.requestAnimationFrame(tick);
    // Call tick again on the next frame
    //console.log("Camera "+camera.position.x + ","+ camera.position.y+ ","+ camera.position.z);
    var delta = clock.getDelta();

    if (mixer) mixer.update(delta);
}


tick()


showAnimation.onclick = function() {
  console.log("Plays the fridge animation..")
  processCard.style.display = "none";
  vectorImageCard.style.display = "block";

  //I'm logging out the animations list, that list will have exact animation names.

  // action_animation.play();
}

showRoute.onclick = function() {
  console.log("Show route animation plays..")
  wrapFix.style.display="none";
  videoDiv.style.display="block";
  video.play();
  // shifts camera positions to the end of the route. Best to use the x.y.z positions for now.

}

showExit.onclick = function() {
  console.log("plays show exit animation..")
  wrapFix.style.display="none";
  videoDiv.style.display="block";
  video.play();
}


cardCloseProcess.onclick = function(){
  processCard.style.display="none";
}

cardCloseVector.onclick = function(){
  vectorImageCard.style.display="none";
}
// vectorImageCard.onclick = function() {
//   console.log("show vector image description..")
// }

video.addEventListener('ended',myHandler,false);
    function myHandler(e) {
      videoDiv.style.display = "none";
      wrapFix.style.display="block";
        // What you want to do after the event
}


var views_on_toggle = [[-15.647204595488851,103.84822017522242,157.84923048167747],[48.904768707611126,18.836481141592618,-12.417200944741015],[-8, 42, 84],[2.272073180803354,202.21451309149788,79.5225613281173]]
var view = 0
var current_toggle;
toggleView.onclick = function() {
  console.log("Toggles thre view..")
  //iterate through the views_on_toggle list and
  //call the Load Model function. 

  view++;
  if (view == views_on_toggle.length) {
    view = 0;
  }
  current_toggle = views_on_toggle[view];
  console.log(current_toggle)
  camera.position.set(current_toggle[0], current_toggle[1], current_toggle[2])
  controls.update();
}


showWebsite.onclick = function() {
  window.location.href = "https://serkierratys.fi/";
}


// This is to clikc on 3D object and load the 2nd pop up. object_to_click is the reference to the object which will be clicked. refer to gltf load function.
interactionManager.add(object_to_click);
object_to_click.addEventListener("click", (event) => {
  console.log(event)
  processCard.style.display = "";

  //open up the 2nd pop up. 
    // processCard.style.display = "block"
})




